'use client'

import { useTranslations } from 'next-intl'
import { DownloadIcon, FileTextIcon } from 'lucide-react'
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip'
import { ContentFileIcon } from '@/components/partials'
import { Button } from '@/components/ui/button'
import { formatFileSize, textLimit, tOptional } from '@/lib/utils'
import { RelatedFileType } from '@/types/file'
import { useFilesStore } from '@/store'

type PropsType = {
  files?: RelatedFileType[]
  title?: string
}

const ContentDetailFiles = ({ files, title }: PropsType) => {
  const t = useTranslations()
  const addToDownloadQueue = useFilesStore(state => state.addToDownloadQueue)

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <FileTextIcon className="h-5 w-5" />
          {title ? tOptional(t, title) : tOptional(t, 'files')}
        </CardTitle>
      </CardHeader>
      <CardContent>
        {files && files.length > 0 ? (
          <div className="grid grid-cols-1 gap-4 lg:grid-cols-2 xl:grid-cols-3">
            {files?.map(file => (
              <Tooltip key={file.id}>
                <TooltipTrigger asChild>
                  <div className="flex items-center justify-between rounded-md border p-3">
                    <div className="flex items-center gap-3">
                      <div className="h-10 w-9 shrink-0">
                        <ContentFileIcon file={file.file} />
                      </div>
                      <div>
                        <p className="font-medium">{textLimit(file.file.name, 25)}</p>
                        <p className="text-muted-foreground text-sm">{formatFileSize(file.file.size)}</p>
                      </div>
                    </div>
                    <Button
                      variant="outline"
                      size="sm"
                      onClick={() => addToDownloadQueue(file.file)}
                      className="flex items-center gap-2">
                      <DownloadIcon className="h-4 w-4" />
                      <span className="hidden lg:inline">{t('download')}</span>
                    </Button>
                  </div>
                </TooltipTrigger>
                <TooltipContent>{file.file.name}</TooltipContent>
              </Tooltip>
            ))}
          </div>
        ) : (
          <p className="text-muted-foreground">{t('no_files')}</p>
        )}
      </CardContent>
    </Card>
  )
}

export default ContentDetailFiles
